export const omiseSubmissionForNonce = (nonce) =>
  nonce.startsWith('tokn_') ? { omiseToken: nonce } : { omiseSource: nonce };
